import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, input, signal } from '@angular/core';
import { StatusBadgeComponent } from '../status-badge/status-badge.component';
import { TitleIfTruncatedDirective } from '../card/title-if-truncated.directive';

/**
 * A person in a list (sharing, recipients): avatar or initials, name over
 * email, an optional neutral badge such as the permission, then projected
 * controls at the end.
 */
@Component({
  selector: 'app-person-row-cabinet',
  templateUrl: './person-row.component.html',
  styleUrl: './person-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
  imports: [StatusBadgeComponent, TitleIfTruncatedDirective],
})
export class PersonRowCabinetComponent {
  readonly name = input<string>('');
  readonly email = input<string>('');
  readonly avatarUrl = input<string | null>(null);
  readonly badge = input<string>('');

  readonly avatarFailed = signal(false);

  readonly displayName = computed(() => this.name().trim() || this.email().trim());

  readonly initials = computed(() => {
    const name = this.name().trim();
    if (name) {
      const words = name.split(/\s+/).filter(Boolean);
      const letters = words.length > 1 ? words[0][0] + words[words.length - 1][0] : words[0][0];
      return letters.toUpperCase();
    }
    return this.email().trim().charAt(0).toUpperCase() || '?';
  });
}
